import React from 'react';
import styled from 'styled-components';
import HowToRead, { SectionShell, SubHeading, Grid, Cell, HeadCell } from './HowToRead';
import DistributionBar from './DistributionBar';
import { ScaleLegend } from './DimensionResults';
import { formatPct, formatMean, questionsByTopDimension } from '../reportModel';

const COLS = '56px minmax(200px, 3fr) minmax(120px, 1.4fr) 70px 60px';

const Badge = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ theme }) => theme.colors.report.priorityBg};
  color: ${({ theme }) => theme.colors.report.noteTitle};
`;

const Code = styled(Cell)`
  font-weight: 800;
  color: ${({ theme }) => theme.colors.report.brand};
`;

export default function QuestionResults({ data, t, lang }) {
  const groups = questionsByTopDimension(data);
  // M2 — hiç bölüm yoksa ara başlık çizilmez ("Diğer Sorular" bir karşılaştırma ima eder).
  const hasDimensions = (data.dimensions || []).length > 0;
  return (
    <SectionShell id="s03" title={t('survey.report.section.s03')} actions={<ScaleLegend t={t} method={data.method} />}>
      <HowToRead t={t}>
        {t('survey.report.help.questions')}
        {(data.method.eligibility || []).map((note) => (
          <div key={note.questionId}>{t('survey.report.help.eligibility', { code: note.code || '', months: note.maxTenureMonths })}</div>
        ))}
      </HowToRead>
      {groups.map((g) => (
        <div key={g.dimension ? g.dimension.id : 'none'}>
          {/* M4 — ara başlıkta yalnız bölüm adı (otomatik "B1" kodu uzman olmayan okura anlamsız). */}
          {hasDimensions && (
            <SubHeading>{g.dimension ? g.dimension.name : t('survey.report.noDimension')}</SubHeading>
          )}
          <Grid $cols={COLS}>
            <HeadCell>{t('survey.report.colCode')}</HeadCell>
            <HeadCell>{t('survey.report.colStatement')}</HeadCell>
            <HeadCell>{t('survey.report.colDistribution')}</HeadCell>
            <HeadCell $align="right">{t('survey.report.colFavorable')}</HeadCell>
            <HeadCell $align="right">{t('survey.report.colMean')}</HeadCell>
            {g.questions.map((q) => (
              <React.Fragment key={q.id}>
                <Code>{q.code || ''}</Code>
                <Cell>
                  {q.text}
                  {q.reverse && <Badge>{t('survey.report.reverseBadge')}</Badge>}
                </Cell>
                <Cell>{q.suppressed ? null : <DistributionBar result={q} height={12} />}</Cell>
                <Cell $bold $align="right">
                  {q.suppressed ? t('survey.report.suppressedCell', { n: data.threshold }) : formatPct(t, q.favorablePct)}
                </Cell>
                <Cell $align="right" $muted>{q.suppressed ? '' : formatMean(q.mean, lang)}</Cell>
              </React.Fragment>
            ))}
          </Grid>
        </div>
      ))}
    </SectionShell>
  );
}
